import React, { useState, useEffect } from "react";

const OpportunityDetailsForm = ({ opportunityDetails, onSave, onCancel }) => {
  const [localDetails, setLocalDetails] = useState(opportunityDetails);

  useEffect(() => {
    setLocalDetails(opportunityDetails);
  }, [opportunityDetails]);

  const handleChange = (field) => (e) => {
    setLocalDetails({ ...localDetails, [field]: e.target.value });
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!localDetails.opportunity_name?.trim()) {
      alert("Opportunity Name is required.");
      return;
    }
    onSave({
      ...localDetails,
      solutionType: localDetails.solution_type, // Correctly mapped
      commit_date: localDetails.commit_date,    // Ensure commit_date is passed
      value: localDetails.value,                // Ensure value is passed
    });
  };

  return (
    <form onSubmit={handleSave}>
      <label>Opportunity Name:</label>
      <input
        type="text"
        value={localDetails.opportunity_name || ""}
        onChange={handleChange("opportunity_name")}
      />

      <label>Contact:</label>
      <input
        type="text"
        value={localDetails.contact || ""}
        onChange={handleChange("contact")}
      />

      <label>Champions:</label>
      <input
        type="text"
        value={localDetails.champions || ""}
        onChange={handleChange("champions")}
      />

      <label>Sales Stage:</label>
      <select
        value={localDetails.stage || ""}
        onChange={handleChange("stage")}
      >
        <option value="">Select</option>
        <option value="Sales Stage 0">Sales Stage 0</option>
        <option value="Sales Stage 1 Discovery">Sales Stage 1 Discovery</option>
        <option value="Sales Stage 2 Demo">Sales Stage 2 Demo</option>
        <option value="Sales Stage 3 Technical Deep Dive">
          Sales Stage 3 Technical Deep Dive
        </option>
        <option value="Sales Stage 4 Proof of Value">
          Sales Stage 4 Proof of Value
        </option>
        <option value="Sales Stage 5 Closing">Sales Stage 5 Closing</option>
      </select>

      <label>Solution Type:</label>
      <input
        type="text"
        value={localDetails.solution_type || ""}
        onChange={handleChange("solution_type")}
      />

      <label>Vendor:</label>
      <input
        type="text"
        value={localDetails.vendor || ""}
        onChange={handleChange("vendor")}
      />

      <label>Commit Date:</label>
      <input
        type="date"
        value={localDetails.commit_date || ""}
        onChange={handleChange("commit_date")}
      />

      <label>Value (in dollars):</label>
      <input
        type="number"
        value={localDetails.value || ""}
        onChange={handleChange("value")}
      />

      <div className="form-buttons">
        <button type="submit">Save</button>
        <button type="button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default OpportunityDetailsForm;
